import { Content } from '@/app/private/my-content/models/content.model';
import { User } from '@/core/models/user.model';
import { WidgetTeacherSectionList } from './widget-teacher-section-list.model';
import { WidgetTeacherPerson } from './widget-teacher-person.model';

export class WidgetTeacherCourse extends Content {
  classId: number;
  maxHeight: number;
  persons: {
    content: WidgetTeacherPerson[];
    more: boolean;
    page: number;
  }
  sections: {
    content: WidgetTeacherSectionList[];
    more: boolean;
    page: number;
    pageSize?: number;
  }
  constructor(data: any) {
    super(data);
    this.classId = data.classId;
    this.persons = { content: [], more: false, page: 0 };
    this.sections = { content: [], more: false, page: 0 };
    this.maxHeight = 0;
  } 
}